import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const SITE = "https://keppel-immobilien.de";
const DEFAULT_TITLE = "Keppel Immobilien · Sanierung in Oberfranken";
const DEFAULT_DESC =
  "Keppel Immobilien kauft und saniert kleine Mehrfamilienhäuser in Oberfranken – behutsam, hochwertig und regional verwurzelt.";

const SEO = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESC,
  },
  "/ueber-uns": {
    title: "Über uns – regional verwurzelt in Oberfranken | Keppel Immobilien",
    description:
      "Wer wir sind: Ein privat geführtes Unternehmen, das alten Häusern in Oberfranken eine neue Zukunft gibt – mit Respekt vor der Substanz und regionalem Handwerk.",
  },
  "/portfolio": {
    title: "Suchprofil – welche Häuser wir suchen | Keppel Immobilien",
    description:
      "Unser Suchprofil: Mehrfamilienhäuser mit Charakter in Oberfranken und Nordbayern, mit leichtem bis vollständigem Sanierungsbedarf. Bieten Sie uns Ihr Haus an.",
  },
  "/verkaufen": {
    title: "Haus verkaufen in Oberfranken | Keppel Immobilien",
    description:
      "Sie möchten Ihr Haus in Oberfranken verkaufen? Wir kaufen Mehrfamilienhäuser direkt, unkompliziert und fair. Jetzt unverbindlich anfragen.",
  },
  "/partner": {
    title: "Partner – Handwerk & Dienstleister der Region | Keppel Immobilien",
    description:
      "Unsere Partner aus Hochfranken: Handwerksbetriebe, Architektur, Notariat und Finanzierung, mit denen wir Häuser mit Qualität sanieren.",
  },
  "/bewerbung": {
    title: "Als Mieter bewerben | Keppel Immobilien",
    description:
      "Interesse an einer unserer sanierten Wohnungen in Oberfranken? Bewerben Sie sich unkompliziert über unser Online-Formular.",
  },
  "/referenzen": {
    title: "Portfolio – aktuelle Objekte in Oberfranken | Keppel Immobilien",
    description:
      "Unsere sanierten und laufenden Objekte in Oberfranken: Vom Stadthaus bis zum ehemaligen Pfarrhaus – mit Vorher/Nachher-Einblicken.",
  },
  "/referenzen/kreuzbergstrasse-haustuer": {
    title: "Sanierungsgeschichte: die neue Haustür Kreuzbergstraße | Keppel Immobilien",
    description:
      "Vorher/Nachher: Wie aus einer billigen Notlösung eine handwerklich gefertigte, enzianblaue Haustür im alten Stil wurde – Dreiparteienhaus Kreuzbergstraße, Münchberg.",
  },
  "/kontakt": {
    title: "Kontakt | Keppel Immobilien",
    description:
      "Sprechen Sie mit uns: Ob Sie ein Haus verkaufen möchten oder als Mieter interessiert sind – wir sind persönlich für Sie da.",
  },
  "/impressum": {
    title: "Impressum | Keppel Immobilien",
    description: "Impressum und Anbieterkennzeichnung der Keppel Immobilien, Münchberg.",
  },
  "/datenschutz": {
    title: "Datenschutzerklärung | Keppel Immobilien",
    description: "Informationen zum Datenschutz und zur Verarbeitung Ihrer Daten bei Keppel Immobilien.",
  },
};

export const RouteSeo = () => {
  const { pathname } = useLocation();
  const key = pathname !== "/" && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  const meta = SEO[key] || { title: DEFAULT_TITLE, description: DEFAULT_DESC };
  const url = SITE + (key === "/" ? "/" : key);

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
    </Helmet>
  );
};
